import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { useAutoComplete } from "hooks/useAutoComplete";
import { useOrganizationListQuery } from "@ticketingplatform/api/dist/organization";

import { UseOrganizationSelect } from "./types";

export const useOrganizationSelect: UseOrganizationSelect = (props) => {
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue<
    string | undefined
  >(undefined, 1000);

  const { data, loading } = useOrganizationListQuery({
    variables: {
      orderBy: [{ name: SortDirection.asc }],
      take: 10,
      filters: {
        ...(debouncedSearch
          ? {
              name: {
                contains: debouncedSearch,
                mode: QueryMode.insensitive,
              },
            }
          : {}),
      },
    },
  });

  return useAutoComplete({
    ...props,
    loading,
    searchValue,
    onSearch,
    options: data?.organizations?.nodes || [],
    valueProp: "id",
    labelProp: "name",
  });
};
